var _a;
/**
 * @hidden
 */
export var nodata = 'dropdowns.nodata';
/**
 * @hidden
 */
export var clear = 'dropdowns.clear';
/**
 * @hidden
 */
export var comboArrowBtnAriaLabelExpand = 'dropdowns.comboArrowBtnAriaLabelExpand';
/**
 * @hidden
 */
export var comboArrowBtnAriaLabelCollapse = 'dropdowns.comboArrowBtnAriaLabelCollapse';
/**
 * @hidden
 */
export var dropDownListArrowBtnAriaLabel = 'dropdowns.dropDownListArrowBtnAriaLabel';
/**
 * @hidden
 */
export var adaptiveModeFooterApply = 'dropdowns.apply';
/**
 * @hidden
 */
export var adaptiveModeFooterCancel = 'dropdowns.cancel';
/**
 * @hidden
 */
export var messages = (_a = {},
    _a[clear] = 'clear',
    _a[nodata] = 'NO DATA FOUND.',
    _a[comboArrowBtnAriaLabelExpand] = 'expand combobox',
    _a[comboArrowBtnAriaLabelCollapse] = 'collapse combobox',
    _a[dropDownListArrowBtnAriaLabel] = 'select',
    _a[adaptiveModeFooterApply] = 'Apply',
    _a[adaptiveModeFooterCancel] = 'Cancel',
    _a);
